<script>
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            sourceContact: String,
            company: {
                type: Object,
                default() {
                    return {}
                }
            },
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                showContactForm: false,
                form: new Form({
                    voucher_type: null,
                    voucher_id: '',
                    for_course_id: null,
                    for_event_id: null,
                    for_summer_camp_id: null,
                    is_promoted: 0
                }),
                contactForm: new Form({
                    voucher_id: '',
                    first_name: this.data.first_name,
                    last_name: this.data.last_name,
                    email: this.data.email,
                    phone: this.company.phone_number,
                    message: 'Ho avuto problemi con il riscatto del mio voucher.'
                })
            }
        },
        computed: {
            disabledButton() {
                if (this.form.voucher_type == 'orangopack') {
                    return !this.form.for_course_id
                } else if (this.form.voucher_type == 'payment_events') {
                    return !this.form.for_event_id
                } else if (this.form.voucher_type == 'summer_camps') {
                    return !this.form.for_summer_camp_id
                }

                return true
            }
        },
        watch: {
            'form.voucher_type': {
                handler(val) {
                    if (val == 'orangopack') {
                        this.$set(this.form, 'for_summer_camp_id', null)
                        this.$set(this.form, 'for_event_id', null)
                    } else if (val == 'summer_camps') {
                        this.$set(this.form, 'for_course_id', null)
                        this.$set(this.form, 'for_event_id', null)
                    } else {
                        this.$set(this.form, 'for_summer_camp_id', null)
                        this.$set(this.form, 'for_course_id', null)
                    }
                }
            }
        },
        mounted() {
            this.initSelectSummerCamps()

            this.initSelectOrangopacks()

            this.initSelectPaymentEvents()

            this.$set(this.form, 'voucher_type', 'orangopack')
        },
        methods: {
            initSelectSummerCamps() {
                let vm = this
                $('#selectSummerCamps').select2({
                    width: '100%',
                    ajax: {
                        url: route('company.summer_camps'),
                        data(params) {
                            let query = {
                                search: params.term,
                                company_id: vm.company.id
                            }
                            return query
                        },
                        processResults({summerCamps}) {
                            let results = []
                            summerCamps.forEach(({id, name}) => {
                                results.push({
                                    id: id,
                                    text: name
                                })
                            });
                            return {
                                results: results
                            }
                        }
                    }
                });

                $('#selectSummerCamps').on('change', function (e) {
                    if ($(this).val()) {
                        vm.$set(vm.form, 'for_summer_camp_id', $(this).val())
                    }
                })
            },
            initSelectOrangopacks() {
                let vm = this
                $('#selectCourse').select2({
                    width: '100%',
                    ajax: {
                        url: route('company.courses'),
                        data(params) {
                            let query = {
                                search: params.term,
                                company_id: vm.company.id
                            }
                            return query
                        },
                        processResults({courses}) {
                            let results = []
                            courses.forEach(({id, name, is_promoted}) => {
                                if (is_promoted) {
                                    results.push({
                                        id: id,
                                        is_promoted: 1,
                                        text: name + " - OrangoPack"
                                    })
                                }
                            });
                            return {
                                results: results
                            }
                        }
                    }
                });

                $('#selectCourse').on('change', function (e) {
                    /*console.log($(this).select2('data')[0].is_promoted);*/
                    if ($(this).val()) {
                        vm.$set(vm.form, 'for_course_id', $(this).val())
                        vm.$set(vm.form, 'is_promoted', $(this).select2('data')[0].is_promoted)
                    }
                })
            },
            initSelectPaymentEvents() {
                let vm = this
                $('#selectEvent').select2({
                    width: '100%',
                    ajax: {
                        url: route('company.events'),
                        data(params) {
                            let query = {
                                search: params.term,
                                company_id: vm.company.id
                            }
                            return query
                        },
                        processResults({events}) {
                            let results = []
                            events.forEach(({id, name}) => {
                                results.push({
                                    id: id,
                                    text: name
                                })
                            });
                            return {
                                results: results
                            }
                        }
                    }
                });

                $('#selectEvent').on('change', function (e) {
                    /*console.log($(this).select2('data')[0].is_promoted);*/
                    if ($(this).val()) {
                        vm.$set(vm.form, 'for_event_id', $(this).val())
                    }
                })
            },
            onSubmit() {
                this.form
                    .submit('post', route('companies.dashboard.vouchers', this.company.slug))
                    .then(response => {
                        $('#selectCourse').val(null).trigger('change')
                        $('#selectSummerCamps').val(null).trigger('change')
                        $('#selectEvent').val(null).trigger('change')
                        window.alerts.success('Voucher valido')
                    })
                    .catch(error => {
                        window.alerts.error('Voucher non valido')
                        this.$set(this, 'showContactForm', true)
                        this.$set(this.contactForm, 'voucher_id', this.form.voucher_id)
                    })
            },
            onSubmitContact() {
                this.contactForm
                    .submit('post', this.sourceContact)
                    .then(response => {
                        $("#successModal").modal('show')
                        window.alerts.success('Richiesta inviata')
                        this.form.reset()
                        this.$set(this, 'showContactForm', false)
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyVoucherForm.vue